import React from 'react'
import { Card, Typography, Table, Tag } from 'antd'
import { CalendarOutlined } from '@ant-design/icons'

const { Title, Text } = Typography

interface ShiftListTabProps {
	shiftList: any[]
}

const ShiftListTab: React.FC<ShiftListTabProps> = ({ shiftList }) => {
	const columns = [
		{
			title: 'Shift ID',
			dataIndex: 'id',
			key: 'id',
			width: 200,
		},
		{
			title: 'Shift Name',
			dataIndex: 'name',
			key: 'name',
			width: 200,
		},
		{
			title: 'Status',
			key: 'status',
			width: 100,
			render: () => <Tag color='green' style={{ borderRadius: 4 }}>Active</Tag>,
		},
	]

	const dataSource = shiftList.map((shift) => ({
		...shift,
		key: shift.id,
	}))

	const CARD_STYLE = {
		borderRadius: 12,
		boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.03)',
	}

	return (
		<Card bordered={false} style={CARD_STYLE}>
			<div style={{ marginBottom: 24 }}>
				<Text type='secondary'>View and manage all available shifts in the organization.</Text>
			</div>

			<Table
				columns={columns}
				dataSource={dataSource}
				size="middle"
				pagination={{
					pageSize: 10,
					showSizeChanger: true,
					showTotal: (total) => `Total ${total} shifts`,
				}}
				locale={{
					emptyText: (
						<div style={{ padding: '40px 0' }}>
							<Text type='secondary'>No shifts found.</Text>
						</div>
					),
				}}
			/>
		</Card>
	)
}

export default ShiftListTab
